<template>
  <div
    class='thanks'
  @click.stop='screenClicked'
    >
    <div class='centered thanks-wrapper'>
      <div class='content'>
        <div class='icon'></div>
        <div class='text'>THANKS</div>
      </div>
    </div>
  </div>
</template>
<script>
import initFade from '@/transitions/initFade'

export default {
  name: 'thanks',
  data () {
    return {
      timer: null,
      timeToGoHome: 10000,
      initFade
    }
  },
  methods: {
    screenClicked () {
      this.backHome()
    },
    clearTimer () {
      if (this.timer) {
        clearTimeout(this.timer)
      }
    },
    backHome () {
      this.$router.push('game')
    },
    initTimer () {
      this.clearTimer()
      this.timer = setTimeout(() => {
        this.backHome()
      }, this.timeToGoHome)
    }
  },
  mounted () {
    this.initFade.initFade('.thanks', 2.8)
    this.initTimer()
  },
  beforeDestroy () {
    this.clearTimer()
  }
}
</script>
<style lang='scss' scoped>
  @keyframes appearance {
    0%, 90%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }

  .thanks {
    background: #ca1720;
    width: 100vw;
    height: 100vh;
    position: relative;
    .content {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      animation: appearance 3.5s infinite ease-out;
      animation-delay: 1.5s;
      height: 520px;
      max-width: 80vw !important;
    }
    .icon {
      height: 200px;
      width: 200px;
      background: url('../../assets/logo-dore.png') center center no-repeat;
      background-size: contain;
      margin-bottom: 50px;
      // -webkit-filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
    }
    .text {
      font-size: 36px;
      width: 460px;
      text-align: center;
      color: #ffffff;
      text-transform: uppercase;
    }
  }
</style>
